module.exports = __webpack_public_path__ + "static/media/beep-2000Hz.417575f6.wav";


//////////////////
// WEBPACK FOOTER
// ./src/components/TimingClock/beep-2000Hz.wav
// module id = 1584
// module chunks = 0